module.exports = __webpack_public_path__ + "static/media/11992092_892389260810716_533105063_n.d3ba89e0.jpg";